import {
  API_URL,
  v,
  put,
  debug,
  request,
  takeEvery,
  createDoRequestAction,
  assertTotalSchema,
  SagaIterator,
  call,
} from "../../lib";
import { doCOLLABORATOR_DELETE, doREQUEST_COMPLETE, doREQUEST_ERROR } from "../state";
import { getToken } from "./token_fetcher";

export const REQUEST_WORKSPACE_COLLABORATOR_DELETE = "REQUEST_WORKSPACE_COLLABORATOR_DELETE";
export const doREQUEST_WORKSPACE_COLLABORATOR_DELETE = createDoRequestAction(
  REQUEST_WORKSPACE_COLLABORATOR_DELETE,
);

export const requestWorkspaceCollaboratorDeleteActionCreators = {
  doREQUEST_WORKSPACE_COLLABORATOR_DELETE,
};

export function* requestWorkspaceCollaboratorDelete({
  payload,
  setRequestResult,
}: any): SagaIterator {
  debug("saga*requestWorkspaceCollaboratorDelete");

  try {
    assertTotalSchema({
      payload,
      schema: v.object({
        requestId: v.string().uuid(),
        workspaceCollaboratorId: v.string().uuid().exist(),
        workspaceId: v.string().uuid().exist(),
      }),
    });
  } catch (error) {
    return yield put(
      doREQUEST_ERROR(
        {
          fromType: REQUEST_WORKSPACE_COLLABORATOR_DELETE,
          requestId: payload.requestId,
          error,
        },
        setRequestResult,
      ),
    );
  }

  const { workspaceId, workspaceCollaboratorId } = payload;

  const accessToken = yield call(getToken);

  const result = yield request({
    method: "post",
    url: `${API_URL}/v1/web/workspace-collaborator-delete`,
    accessToken,
    data: {
      workspaceCollaboratorId,
    },
  });

  if (!result.success || result.error) {
    const error = result.error || new Error("request did not succeed");
    debug(error);
    return yield put(
      doREQUEST_ERROR(
        {
          fromType: REQUEST_WORKSPACE_COLLABORATOR_DELETE,
          fromPayload: payload,
          requestId: payload.requestId,
          url: "/v1/web/workspace-collaborator-delete",
          ...result,
          error,
        },
        setRequestResult,
      ),
    );
  }

  yield put(
    doCOLLABORATOR_DELETE({
      id: workspaceCollaboratorId,
      workspaceId: workspaceId,
    }),
  );

  yield put(
    doREQUEST_COMPLETE(
      {
        fromType: REQUEST_WORKSPACE_COLLABORATOR_DELETE,
        requestId: payload.requestId,
        ...result,
      },
      setRequestResult,
    ),
  );
}

export function* workspaceCollaboratorDeleteSaga() {
  yield takeEvery(REQUEST_WORKSPACE_COLLABORATOR_DELETE, requestWorkspaceCollaboratorDelete);
}
